// FIX: 移除未使用的import
// import { apiLogin } from '@/api/app'

// State
const state = {
    config: {},
}

const getters = {
    config: state => state.config
}

// Mutations
const mutations = {
    setConfig(state, data) {
        state.config = data
    }
}

// Actions
const actions = {
    
}

// FIX: 变量名从user改为app，与模块功能一致
const app = {
    state,
    mutations,
    actions,
    getters
}

export default app
